<template>
  <div class="ag-grid-date-range-floating-filter" @click="showFilter">
    <input
      class="ag-floating-filter-input"
      type="text"
      readonly
      :placeholder="placeholder"
      :title="label"
      :value="label">
  </div>
</template>

<script>
import Vue from 'vue'

/**
 * Floating filter for the columns filtered by AgGridDateRangeFilter. Two dates do not fit one box,
 * so this reads the span back rather than taking it: clicking it opens the filter the dates are
 * picked in, the way the search columns' floating filter does.
 *
 * Configured through the column's floatingFilterComponentParams:
 *   placeholder   Shown while the column is not filtered, e.g. 'Date'
 */
export default Vue.extend({
  name: 'AgGridDateRangeFloatingFilter',

  data () {
    return {
      label: ''
    }
  },

  computed: {
    placeholder () {
      return this.params.placeholder || ''
    }
  },

  methods: {
    /**
     * ag-grid IFloatingFilterComp: the parent filter's model changed. The span is read the way the
     * filter itself writes it, so both say the same thing.
     * @param parentModel
     */
    onParentModelChanged (parentModel) {
      const from = (parentModel && parentModel.dateFrom) || ''
      const to = (parentModel && parentModel.dateTo) || ''
      if (from && to) this.label = `${from} to ${to}`
      else if (from) this.label = `From ${from}`
      else if (to) this.label = `To ${to}`
      else this.label = ''
    },
    showFilter () {
      this.params.showParentFilter()
    }
  }
})
</script>

<style scoped>
  .ag-grid-date-range-floating-filter {
    width: 100%;
  }
  .ag-grid-date-range-floating-filter input {
    width: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/AgGridDateRangeFloatingFilter.vue